var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("aside", { ref: "sidebar", attrs: { id: "sidebar" } }, [
    _c(
      "div",
      { staticClass: "scrollable-area" },
      [
        _c("div", { staticClass: "logo-container" }, [
          _c("img", {
            staticClass: "logo",
            attrs: {
              src:
                "img/logo-" +
                (_vm.isPublic() ? "horizontal-" : "") +
                "transparent-bg.svg",
              alt: "The Lounge",
              role: "presentation",
            },
          }),
          _c("img", {
            staticClass: "logo-inverted",
            attrs: {
              src:
                "img/logo-" +
                (_vm.isPublic() ? "horizontal-" : "") +
                "transparent-bg-inverted.svg",
              alt: "The Lounge",
              role: "presentation",
            },
          }),
        ]),
        _c("NetworkList"),
      ],
      1
    ),
    _c("footer", { attrs: { id: "footer" } }, [
      _c(
        "span",
        {
          staticClass: "tooltipped tooltipped-n tooltipped-no-touch",
          attrs: { "aria-label": "Connect to network" },
        },
        [
          _c("router-link", {
            class: ["icon", "connect"],
            attrs: {
              to: "/connect",
              tag: "button",
              "active-class": "active",
              "aria-label": "Connect to network",
              role: "tab",
              "aria-controls": "connect",
              "aria-selected": _vm.$route.name === "Connect",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v("\n© Shprehu Chat "),
    _c("br"),
    _c("b", [_vm._v("AdmiraL")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }